import {
  AutoAwesomeMosaicSharp,
  BarChart,
  EmojiPeople,
  Games,
  Group,
  Home,
  Logout,
  People,
  PersonSearch,
  SvgIconComponent,
} from "@mui/icons-material";
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Paper,
  Toolbar,
  Typography,
} from "@mui/material";
import { useSidebar } from "./hooks/useSidebar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { authApi } from "./services/authServices";
import { getAdminSectionFromPath } from "./adminNav";
interface drawerItem {
  text: string;
  icon: SvgIconComponent;
  url: string;
  disabled?: boolean;
}

const drawerListElements: drawerItem[] = [
  {
    text: "Joukkueet",
    icon: Group,
    url: "teams",
  },
  {
    text: "Matsit",
    icon: Games,
    url: "matches",
  },
  {
    text: "Henkilökunta",
    icon: EmojiPeople,
    url: "staff",
  },
  {
    text: "Pelaajat",
    icon: People,
    url: "players",
  },
  {
    text: "Tunnistamattomat",
    icon: PersonSearch,
    url: "pending",
  },
  {
    text: "Liikenne",
    icon: BarChart,
    url: "traffic",
  },
  {
    text: "Fantasy",
    icon: AutoAwesomeMosaicSharp,
    url: "fantasy",
    disabled: true,
  },
  {
    text: "Kotiin",
    icon: Home,
    url: "/",
  },
  {
    text: "Kirjaudu ulos",
    icon: Logout,
    url: "/logout",
  },
];

const isNavSection = (url: string) => url !== "/" && url !== "/logout";

export const Sidebar = () => {
  const { switchView } = useSidebar();
  const navigate = useNavigate();
  const location = useLocation();
  const activeSection = getAdminSectionFromPath(location.pathname);
  const imgs = import.meta.env.VITE_S3_ASSET_URL || "";

  const handleLogout = async (): Promise<void> => {
    try {
      await authApi.logout();
    } catch (err) {
      console.error("Backend cookie clearing failed:", err);
    } finally {
      console.log("DELETE");
      void navigate("/auth", { replace: true });
    }
  };

  return (
    <Paper
      sx={{
        display: "flex",
        width: "100vw",
        height: "100vh",
      }}
    >
      <Drawer
        variant="permanent"
        anchor="left"
        open
        sx={{
          width: { xs: "12rem", sm: "25rem" },
          px: "1rem",
          "& .MuiDrawer-paper": { width: { xs: "12rem", sm: "25rem" }, px: "1rem" },
        }}
      >
        <Toolbar>
          <img
            style={{ padding: "2rem" }}
            width={32}
            src={`${imgs}/icons/finnhouse.png`}
            alt="Finnhouse"
          />
          <Typography>Finnhouse Dashboard</Typography>
        </Toolbar>
        <Divider />
        <List>
          {drawerListElements.map((item, index) => {
            const isSelected =
              isNavSection(item.url) && !item.disabled && item.url === activeSection?.url;

            return (
              <ListItemButton
                disabled={item.disabled}
                selected={isSelected}
                onClick={() => {
                  if (item.url === "/logout") {
                    void handleLogout();
                  } else {
                    void switchView(item.url);
                  }
                }}
                key={index}
                sx={{
                  marginBottom: "0.5rem",
                  textAlign: "center",
                  borderRadius: 1,
                  "&.Mui-selected": {
                    bgcolor: "primary.main",
                    color: "primary.contrastText",
                    "&:hover": {
                      bgcolor: "primary.dark",
                    },
                    "& .MuiListItemIcon-root": {
                      color: "inherit",
                    },
                  },
                }}
              >
                <ListItemIcon>
                  <item.icon />
                </ListItemIcon>
                <ListItemText primary={item.text} />
              </ListItemButton>
            );
          })}
        </List>
        <Divider />
      </Drawer>
      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: 0,
          overflowY: "auto",
          maxHeight: "100vh",
          px: "2rem",
        }}
      >
        <Outlet />
      </Box>
    </Paper>
  );
};
